import script from "./Dates.vue?vue&type=script&setup=true&lang=js"
export * from "./Dates.vue?vue&type=script&setup=true&lang=js"

import "./Dates.vue?vue&type=style&index=0&id=79c29ee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c29ee8"]])

export default __exports__